module.exports = __webpack_public_path__ + "img/Shark.45690b0b.png";